<script lang="ts">
export default {
  name: "BaseBadge",
};
</script>

<!-- TODO: clean up props, check usage
 https://github.com/101skills-gmbh/fobizz-rails/issues/2136
- state "purple"?
- smallXPadding?
- largeYPadding? 
- noMargin?
-->

<script setup lang="ts">
export type Props = {
  state?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark"
    | "purple";
  rounded?: boolean;
  smallXPadding?: boolean;
  largeYPadding?: boolean;
  noMargin?: boolean;
};

withDefaults(defineProps<Props>(), {
  state: "secondary",
  smallXPadding: false,
  largeYPadding: false,
  noMargin: false,
});
</script>

<template>
  <span
    :class="`badge bg-${state} ${rounded ? 'rounded-pill' : ''} ${smallXPadding ? 'px-1' : ''} ${noMargin ? '' : 'me-1 ms-1'}`"
    :style="`${largeYPadding ? 'padding-top: 0.45rem; padding-bottom: 0.45rem' : ''} `"
  >
    <slot></slot>
  </span>
</template>

<style scoped lang="scss">
.badge {
  height: 100%;
  width: fit-content;
}

.bg-purple {
  background-color: $color-system-meta;
}
</style>
